import React, {useState} from "react";
import { useSelector } from "react-redux";
import styled from "styled-components";
import { useDispatch } from "react-redux";
import moment from "moment";
import { MdOutlineMoreHoriz } from "react-icons/md";
import { approveDriverJobSeekerAdmin } from "../../../features/admin3/admin3Slice";
import { setSelectedAdvertiser } from "../../../features/ilanlar/ilanlarSlice";
import { showModal } from "../../../features/modal/modalSlice";


const Container = styled.div`
  width: 100%;
  margin-block: 10px;
  background-color: ${({ theme }) => theme.secondaryBgColor};
  .container {
    width: 100%;

    .content {
      width: 100%;
      padding: 15px 10px;
      border-radius: 10px;
      margin: 10px 0px 0px 0px !important;
      position: relative;
      background-color: var(--color-light);
      .row {
        width: 100%;
        display: grid;
        grid-template-columns: repeat(13, 1fr); 
        align-items: center;
        justify-content: center;
        min-height: 40px;
        height: auto;
        .col {
          font-size: var(--font-size-sm);
          font-weight: var(--font-weight-md);
          text-align: center;
          gap: 10px;
          display: flex;
          flex-direction: column;
          
          p{
            border: 1px solid var(--color-main);
            padding: 5px;
            border-radius: 5px;
            color: var(--color-main);
            cursor: pointer;
          }
        }
      }
      .more{
        position: absolute;
        right: 10px;
        cursor: pointer;
        font-size: 20px;
      }
      .detail{
        position: absolute;
        top: 10px;
        right: 40px;
        background-color: white;
        padding: 10px;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        gap: 5px;
        cursor: pointer;
        font-size: var(--font-size-sm);
        font-weight: var(--font-weight-md);
        color: var(--color-main);
        
      }
    }
  }
`;

const AdminIsArayanSurucuContainer = ({ data }) => {
  const { theme } = useSelector((state) => state.layout);
  const dispatch = useDispatch();

  const handleAprove = ({item, approve}) => {
    dispatch(approveDriverJobSeekerAdmin({id: item?.id, isApproved:approve }))
  }

  return (
    <Container onClick={()=> {dispatch(setSelectedAdvertiser(data)); dispatch(showModal("adminDriverJobSeekerOptions")) }} theme={theme}>
      <div className="container">
        <div className="content">
          <div className="row">
            <div className="col">{moment(data?.createdDate).format("DD.MM.YYYY")}</div>
            <div className="col">{data?.firstLastName}</div>
            <div className="col">{data?.contactNumber}</div>
            <div className="col">{data?.ehliyetTurleri?.b && "B"} {data?.ehliyetTurleri?.be && ", BE"} {data?.ehliyetTurleri?.c1 && ", C1"} {data?.ehliyetTurleri?.c && ", C"} {data?.ehliyetTurleri?.ce && ", CE"} {data?.ehliyetTurleri?.d && ", D"} {data?.ehliyetTurleri?.de && ", DE"} {data?.ehliyetTurleri?.g && ", G"}</div>
            <div className="col">{data?.srcBelgeleri?.src1 && "SRC1"} {data?.srcBelgeleri?.src2 && ", SRC2"} {data?.srcBelgeleri?.src3 && ", SRC3"} {data?.srcBelgeleri?.src4 && ", SRC4"} {data?.srcBelgeleri?.src5&& ", SRC5"}</div>
            <div className="col">{data?.driverJobSeekerWorkCities?.map((item) => (
              <span>{item.city}, </span>
            ))}</div>
            <div className="col">{data?.salary}</div>
            <div className="col">{data?.heavyVehicleExperience}</div>
            <div className="col">{data?.description}</div>
            <div className="col">{moment(data?.advertEndDate).format("YYYY.MM.DD")}</div>
            {data?.isApproved === 0 && <div onClick={(e) => e.stopPropagation()} className="col">
              <p onClick={() => handleAprove({item: data, approve: 1})}>Onayla</p>
              <p onClick={() => handleAprove({item: data, approve: 2})}>Reddet</p>
            </div> }
            {data?.isApproved === 1 && <div className="col">Onaylandı</div> }
            {data?.isApproved === 2 && <div className="col">Reddedildi</div> }
            <div className="col">{data?.isActive === true ? "Yayında" : "Arşivde"}</div>
            <div className="col">{data?.isVehicleRented === true ? "Evet" : "Hayır"}</div>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default AdminIsArayanSurucuContainer;
